import React from 'react';
import { LegalPage } from '../components/LegalPage';

const About = () => (
  <LegalPage
    testId="about-page"
    eyebrow="About Luggagefreejourney"
    title="We carry the weight, so you don't have to."
    updated="July 2026"
  >
    <p>
      <strong>Luggage Free Journey</strong> is India's doorstep luggage pickup &amp; delivery
      service — built for travellers who would rather board a flight, train, or cab
      with just a backpack and pick up their bags at the destination, fresh and untouched.
    </p>

    <p>
      Whether you are relocating between cities, checking out of a hotel a day early,
      or simply refusing to lug 25 kg through a metro rush — we take care of the entire
      journey between your two addresses, tracked end-to-end and insured up to ₹10,000.
    </p>

    <h2>Why we exist</h2>
    <p>
      Airline baggage fees keep climbing. Train luggage allowances are strict.
      Cabs and rickshaws add another hop with expensive per-bag surcharges.
      And even after all of that, your bags travel with you — never alone, never on
      their own schedule. We wanted to change that.
    </p>
    <p>
      Luggage Free Journey lets you decouple your travel plans from your luggage plans.
      Book a pickup slot, hand over your bags to a verified agent, and pick them up
      at your destination — often before you even land.
    </p>

    <h2>What we do differently</h2>
    <ul>
      <li><strong>Doorstep-to-doorstep</strong> — pickup and delivery at exact addresses, not just city hubs.</li>
      <li><strong>OTP-verified handover</strong> — every bag is released only after the customer's registered mobile receives &amp; shares a 6-digit code.</li>
      <li><strong>Insured up to ₹10,000</strong> — automatic cover on every booking, with the option to declare higher value at booking time.</li>
      <li><strong>Real-time WhatsApp updates</strong> — from PICKED UP to IN TRANSIT to OUT FOR DELIVERY, you know exactly where your bag is.</li>
      <li><strong>Transparent per-kg pricing</strong> — no surge, no surprise fees, printable invoices auto-sent on delivery.</li>
    </ul>

    <h2>Where we operate</h2>
    <p>
      We currently serve the metros and tier-1 cities of India: Bangalore, Mumbai,
      Delhi NCR, Hyderabad, Chennai, Kolkata, Pune, Ahmedabad, Kochi and Kolkata —
      with new cities being added every quarter. Check the booking page for the
      full, up-to-date list.
    </p>

    <h2>Team &amp; support</h2>
    <p>
      We are a small, tightly-knit team of logistics operators, engineers and
      customer-experience folks. If you ever need to talk to a human, write to
      us at <a href="mailto:support@luggagefreejourney.com">support@luggagefreejourney.com</a> —
      most emails receive a personal reply within 4 working hours.
    </p>
  </LegalPage>
);

export default About;
